import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import dayjs from "dayjs";

import ModalLoad from '../../../components/modal/ModalLoad';
import ModalPopupMessage from '../../../components/modal/ModalPopupMessage';

function SubAdminCommonSystem(props) {
    const formcomRef = useRef(null)
    const irrcontractRef = useRef(null)
    const formfileRef = useRef(null)
    const file_imgRef = useRef(null)

    const [commonsystemitem, setCommonsystemitem] = useState({
        sitename_en: '',
        sitename_th: '',
        siteaddress: '',
        sitecode_txt: '',
        billing_customer: '',
        billing_address: '',
        solar_type: '',
        capacity: 0,
        factor_area: 0,
        factor_stc: 0,
        cod_date: dayjs(new Date()),
        contract_discount_1: 0,
        contract_discount_2: 0,
        contract_irr: 0,
        plc_ip: '',
        inv_model: '',
        shutdown_enable: false,
        edittime: '',
        tariff_txt: ''
    });

    const [modal_file, setmodal_file] = useState(false)
    const [modal_load, setmodal_load] = useState({ enable: false, message: "" })
    const [modal_popup, setModal_popup] = useState({
        modaltype: '',
        headers: '',
        message: '',
        enable: false
    });
    const sleep = ms => new Promise(resolve => setTimeout(resolve, ms))

    function PopupMsg_onGeneral(message) {
        setModal_popup({
            modaltype: '',
            headers: '',
            message: '',
            enable: false
        });
    }

    function PopupMsg_onConfirm(message) {

    }

    useEffect(() => {
        api_get_list()
        return () => {
            setCommonsystemitem({});
        }
    }, []);

    async function api_get_list() {
        setmodal_load({ enable: true, message: "Loading common system." })
        await sleep(500)

        const formData = new FormData()
        axios.post(process.env.REACT_APP_API_URL + props.permitdata.proxy + "/api/setting/common/getdata", formData, {
            headers: {
                Accept: 'application/json',
                'Content-Type': 'multipart/form-data;',
                "Authorization": "Bearer " + props.permitdata.token
            },
        })
            .then((response) => {
                setmodal_load({ enable: false, message: "" })
                if (response.data.status === 'OK') {
                    setCommonsystemitem(response.data.commonsystem)
                } else {
                    setModal_popup({
                        modaltype: 'modal-error',
                        headers: 'Error',
                        message: response.data.message,
                        enable: true
                    })
                }
            })
            .catch((err) => {
                setmodal_load({ enable: false, message: "" })
                setModal_popup({
                    modaltype: 'modal-error',
                    headers: 'Error',
                    message: err.message,
                    enable: true
                })
            });
    }

    async function api_reboot() {
        setmodal_load({ enable: true, message: "Rebooting application....." })
        await sleep(500)

        const formData = new FormData()
        axios.post(process.env.REACT_APP_API_URL + props.permitdata.proxy + "/api/setting/app/reboot", formData, {
            headers: {
                Accept: 'application/json',
                'Content-Type': 'multipart/form-data;',
                "Authorization": "Bearer " + props.permitdata.token
            },
        })
            .then((response) => {
                setmodal_load({ enable: false, message: "" })
                if (response.data.status === 'OK') {
                    setModal_popup({
                        modaltype: 'modal-success',
                        headers: 'Success',
                        message: "Your application has been recieved reboot command.",
                        enable: true
                    });
                } else {
                    setModal_popup({
                        modaltype: 'modal-error',
                        headers: 'Error',
                        message: response.data.message,
                        enable: true
                    })
                }
            })
            .catch((err) => {
                setmodal_load({ enable: false, message: "" })
                setModal_popup({
                    modaltype: 'modal-error',
                    headers: 'Error',
                    message: err.message,
                    enable: true
                })
            });
    }

    async function api_import_image() {
        setmodal_load({ enable: true, message: "Import site image...." })
        await sleep(500)

        const formData = new FormData();
        formData.append('file_img', file_imgRef.current.files[0])
        axios.post(process.env.REACT_APP_API_URL + props.permitdata.proxy + "/api/setting/common/importimg", formData, {
            headers: {
                Accept: 'application/json',
                'Content-Type': 'multipart/form-data;',
                "Authorization": "Bearer " + props.permitdata.token
            },
        })
            .then((response) => {
                setmodal_load({ enable: false, message: "" })
                if (response.data.status === 'OK') {
                    setmodal_file(false)
                    setModal_popup({
                        modaltype: 'modal-success',
                        headers: 'Success',
                        message: "Your site image has been imported.",
                        enable: true
                    });
                }
                else {
                    setModal_popup({
                        modaltype: 'modal-error',
                        headers: 'Error',
                        message: response.data.message,
                        enable: true
                    })
                }
            })
            .catch((err) => {
                setmodal_load({ enable: false, message: "" })
                setModal_popup({
                    modaltype: 'modal-error',
                    headers: 'Error',
                    message: err.message,
                    enable: true
                })
            });
    }

    function rerset_input_img() {
        file_imgRef.current.value = null
    }

    function BackCenter() {
        if (props.permitdata !== null && props.permitdata !== undefined) {
            if (props.permitdata.user_mode !== null && props.permitdata.user_mode !== undefined) {
                if (props.permitdata.user_mode === "center") {
                    return <button className='back-center-btn' onClick={() => {
                        props.callback_backcenter()
                    }}>Back to Center</button>
                }
            }
        }
    }

    return (
        <div id="page-content">
            <div className="panel">
                <div className="panel-body">
                    <div className="row mb-2">
                        <div className="col-xl-12">
                            <div className='d-flex justify-content-between'>
                                <div>
                                    <h4 className="mb-1"><i className="fas fa-home"></i> Common System</h4>
                                    <p className="mb-3">Manage all common system</p>
                                </div>
                                <div>
                                    {BackCenter()}
                                </div>
                            </div>
                            <hr className="new-section-xs mt-0 mb-2" />
                            <div className="d-flex justify-content-start gap-3 mt-2">
                                <button className="btn btn-success btn-sm" type="button" onClick={() => { api_get_list() }}><i className="fas fa-sync-alt"></i> Refresh</button>
                                <button className="btn btn-danger btn-sm" type="button" onClick={() => { api_reboot() }}><i className="fas fa-power-off"></i> Reboot Service</button>
                                <button className="btn btn-info btn-sm" type="button" onClick={() => { setmodal_file(true) }}><i className="fas fa-coins"></i> Import Site Image</button>
                            </div>
                        </div>
                    </div>

                    <form ref={formcomRef} className='mt-3 mb-1 mb-md-4' action="" method="POST" encType="multipart/form-data" >
                        <div className="row">
                            <h6>Site Information</h6>
                            <div className="col-xl-6 mb-1">
                                <div className="form-group mb-3">
                                    <label htmlFor="sitename_en">Site Name EN</label>
                                    <input type="text" className="form-control" name="sitename_en" value={commonsystemitem.sitename_en} required readOnly />
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-xl-6 mb-1">
                                <div className="form-group mb-3">
                                    <label htmlFor="sitename_th">Site Name TH</label>
                                    <input type="text" className="form-control" name="sitename_th" value={commonsystemitem.sitename_th} required readOnly />
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-xl-6 mb-1">
                                <div className="form-group mb-3">
                                    <label htmlFor="siteaddress">Site Address</label>
                                    <input type="text" className="form-control" name="siteaddress" value={commonsystemitem.siteaddress} required readOnly />
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-4 col-xl-2 mb-1">
                                <div className="form-group mb-3">
                                    <label htmlFor="sitecode_txt">Site Code Text</label>
                                    <input type="text" className="form-control" name="sitecode_txt" value={commonsystemitem.sitecode_txt} required readOnly />
                                </div>
                            </div>
                            <div className="col-md-4 col-xl-2 mb-1">
                                <div className="form-group mb-3">
                                    <label htmlFor="solar_type">Solar Type</label>
                                    <input type="text" className="form-control" name="solar_type" value={commonsystemitem.solar_type} required readOnly />
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <h6>Billing Info</h6>
                            <div className="col-xl-6 ">
                                <div className="form-group mb-3">
                                    <label htmlFor="billing_customer">Billing Customer Name</label>
                                    <input type="text" className="form-control" name="billing_customer" value={commonsystemitem.billing_customer} required readOnly />
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-xl-6">
                                <div className="form-group mb-3">
                                    <label htmlFor="billing_address">Billing Customer Address</label>
                                    <input type="text" className="form-control" name="billing_address" value={commonsystemitem.billing_address} required readOnly />
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <h6>Site Specification</h6>
                            <div className="col-md-4 col-xl-2">
                                <div className="form-group mb-3">
                                    <label htmlFor="capacity_1">Capacity (kWp)</label>
                                    <input type="number" className="form-control" name="capacity" min={1} step={0.01} value={commonsystemitem.capacity} required readOnly />
                                </div>
                            </div>
                            <div className="col-md-4 col-xl-2">
                                <div className="form-group mb-3">
                                    <label htmlFor="factor_area_1">Panel Area (m<sup>2</sup>)</label>
                                    <input type="number" className="form-control" name="factor_area" min={1} step={0.01} value={commonsystemitem.factor_area} required readOnly />
                                </div>
                            </div>
                            <div className="col-md-4 col-xl-2">
                                <div className="form-group mb-3">
                                    <label htmlFor="factor_stc_1">PV STC Factor</label>
                                    <input type="number" className="form-control" name="factor_stc" min={0.0001} step={0.0001} value={commonsystemitem.factor_stc} required readOnly />
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <h6>Parameter of Contract</h6>
                            <div className="col-md-4 col-xl-2">
                                <div className="form-group mb-3">
                                    <label htmlFor="contract_discount_1">Discount of Contract (%) P1</label>
                                    <input type="number" className="form-control" name="contract_discount_1" min={0.01} max={100} step={0.01} value={commonsystemitem.contract_discount_1} required readOnly />
                                </div>
                            </div>
                            <div className="col-md-4 col-xl-2">
                                <div className="form-group mb-3">
                                    <label htmlFor="contract_discount_2">Discount of Contract (%) P2</label>
                                    <input type="number" className="form-control" name="contract_discount_2" max={100} step={0.01} value={commonsystemitem.contract_discount_2} required readOnly />
                                </div>
                            </div>
                            <div className="col-md-4 col-xl-2">
                                <div className="form-group mb-3">
                                    <label htmlFor="contract_irr">Irradiation of Contract (kWh/m<sup>2</sup> /yr.)</label>
                                    <input type="number" className="form-control" ref={irrcontractRef} name="contract_irr" min={1} step={0.01} value={commonsystemitem.contract_irr} required readOnly />
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <h6>Other Information & Setting</h6>
                            <div className="col-md-4 col-xl-2">
                                <div className="form-group mb-3">
                                    <label htmlFor="cod_date">COD Date</label>
                                    <input type="text" className="form-control" name="cod_date" value={commonsystemitem.cod_date} required readOnly />
                                </div>
                            </div>
                            <div className="col-md-4 col-xl-2">
                                <div className="form-group mb-3">
                                    <label htmlFor="plc_ip">PLC IP Address</label>
                                    <input type="text" className="form-control" name="plc_ip" value={commonsystemitem.plc_ip} required readOnly />
                                </div>
                            </div>
                            <div className="col-md-4 col-xl-2">
                                <div className="form-group mb-3">
                                    <label htmlFor="inv_model">Inverter Model</label>
                                    <input type="text" className="form-control" name="inv_model" value={commonsystemitem.inv_model} required readOnly />
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <h6>Protection & Tariff</h6>
                            <div className="col-md-4 col-xl-2">
                                <div className="form-group mb-3">
                                    <label htmlFor="shutdown_enable">INV Shutdown Mode</label>
                                    <input type="text" className="form-control" name="shutdown_enable" value={commonsystemitem.shutdown_enable === true ? "Enabled" : "Disabled"} required readOnly />
                                </div>
                            </div>
                            <div className="col-md-8 col-xl-4">
                                <div className="form-group mb-3">
                                    <label htmlFor="tariff_type">Type of Tariff</label>
                                    <input type="text" className="form-control" name="tariff_type" value={commonsystemitem.tariff_txt} required readOnly />
                                </div>
                            </div>
                        </div>
                        <div className="row mb-3">
                            <div className="col-xl-6">
                                <div className="form-group">
                                    <label htmlFor="edittime">Edit Time</label>
                                    <input type="text" className="form-control" name="edittime" value={commonsystemitem.edittime} readOnly />
                                </div>
                            </div>
                        </div>
                    </form>
                    <hr className="new-section-xs" />

                    {
                        modal_file ?
                            <div className='modal-overlay'>
                                <div className="modal d-block" >
                                    <div className="modal-dialog modal-lg modal-dialog-centered">
                                        <div className="modal-content">
                                            <div className="modal-header">
                                                <h4 className="modal-title">Site Image Import</h4>
                                                <i className="fe-x modal-close" onClick={() => { setmodal_file(false) }}></i>
                                            </div>
                                            <div className="modal-body">
                                                <form ref={formfileRef} action="" method="POST" encType="multipart/form-data">
                                                    <div className="row">
                                                        <div className="col-md-12">
                                                            <div className="form-group mb-3">
                                                                <label htmlFor="file_img">Site Image File</label>
                                                                <input type="file" className="form-control" ref={file_imgRef} name="file_img" accept=".png" />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </form>
                                            </div>
                                            <div className="modal-footer">
                                                <button className="btn btn-light btn-sm" type="button" onClick={() => { setmodal_file(false); rerset_input_img() }}><i className="fe-x"></i> Cancel</button>
                                                <button className="btn btn-warning btn-sm" onClick={() => { api_import_image() }}><i className="fe-save"></i> Save</button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            :
                            null
                    }

                </div>
            </div>
            {modal_load.enable ? <ModalLoad option={modal_load} /> : null}
            {modal_popup.enable ? <ModalPopupMessage option={modal_popup} onConfirm={PopupMsg_onConfirm} onGeneral={PopupMsg_onGeneral} /> : null}
        </div>
    )
}

export default SubAdminCommonSystem